import Index from './index.vue'

export default {
  name: 'agencyJobApplicantList',
  path: '/v-agency/job/:jobId/application',
  component: Index,
  meta: {
    isInclude: true,
    titleI18nKey: 'admin.application.applicantList.title.list'
  }
}
